import { useFormEditor } from "@/components/forms/form-editor-context.ts";
import { ApiFormEdit } from "@/types/forms/form-edit.types.ts";
import { DropResult } from "@hello-pangea/dnd";

export const useFormDragDrop = () => {
  const { methods, handleSaveForm } = useFormEditor();
  const { getValues, setValue } = methods;

  const handleDragEnd = (result: DropResult) => {
    const { source, destination, type } = result;

    if (
      !destination ||
      (source.droppableId === destination.droppableId && source.index === destination.index)
    ) {
      return;
    }

    const formData = getValues() as ApiFormEdit;

    if (type === "element") {
      const [srcPageIndex, srcSectionIndex] = source.droppableId.split("-").map(Number);
      const [destPageIndex, destSectionIndex] = destination.droppableId.split("-").map(Number);

      const sourceElements = formData.pages[srcPageIndex].sections[srcSectionIndex].elements;
      const [draggedElement] = sourceElements.splice(source.index, 1);

      const destinationElements = formData.pages[destPageIndex].sections[destSectionIndex].elements;
      destinationElements.splice(destination.index, 0, draggedElement);

      setValue(`pages.${srcPageIndex}.sections.${srcSectionIndex}.elements`, sourceElements);
      setValue(`pages.${destPageIndex}.sections.${destSectionIndex}.elements`, destinationElements);
    } else if (type === "section") {
      const srcPageIndex = Number(source.droppableId.split("-")[1]);
      const destPageIndex = Number(destination.droppableId.split("-")[1]);

      const pageSections = formData.pages[srcPageIndex].sections;
      const [draggedSection] = pageSections.splice(source.index, 1);

      const destSections = formData.pages[destPageIndex].sections;
      destSections.splice(destination.index, 0, draggedSection);

      setValue(`pages.${srcPageIndex}.sections`, pageSections);
      setValue(`pages.${destPageIndex}.sections`, destSections);
    } else if (type === "page") {
      const pages = [...formData.pages];
      const [draggedPage] = pages.splice(source.index, 1);

      pages.splice(destination.index, 0, draggedPage);

      setValue("pages", pages);
    }

    handleSaveForm();
  };

  return { handleDragEnd };
};
